<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import Cta from "./CTA.svelte"
    import OrderStatusIcons from "./table/fields/OrderStatusIcons.svelte"

    export let icon: string = "",
        title: string = "",
        content: string[] = [],
        showOrderIcon = "",
        initiallyCollapsed
    let collapsed = initiallyCollapsed
    let dispatch = createEventDispatcher()
    let innerWidth = typeof window !== "undefined" ? window.innerWidth : 1000
    function groupArray(data: string | any[], groupSize: number) {
        let result = []
        for (let i = 0; i < data.length; i += groupSize) {
            result.push(data.slice(i, i + groupSize))
        }
        return result
    }
</script>

<svelte:window bind:innerWidth="{innerWidth}" />

<div class="collapsible-wrapper">
    <div class="innerHeader">
        {#if title}
            <div class="title">
                <div class="icon">
                    <img
                        src="../../../assets/icons/{icon}"
                        alt="icon"
                    />
                </div>
                <h2>{title}</h2>
            </div>
        {:else}
            {#if showOrderIcon}
                <OrderStatusIcons status="{showOrderIcon || 'open'}" />
            {/if}

            <ul class="content">
                {#if innerWidth >= 1700}
                    {#each content as entry}
                        <li class="contentTextBold">
                            {entry}
                        </li>
                    {/each}
                {:else}
                    <!--make groups of 2, so two elements below eachother and then a new li-->
                    {#each groupArray(content, 2) as group}
                        <li class="contentTextBold">
                            <ul>
                                {#each group as entry}
                                    <li>{entry}</li>
                                {/each}
                            </ul>
                        </li>
                    {/each}
                {/if}
            </ul>
        {/if}
        <div class="buttons">
            {#if innerWidth >= 1700}
                <ul class="actionButtons"><slot name="actionButtons" /></ul>
            {/if}
            <button on:click|stopPropagation|preventDefault="{() => (collapsed = !collapsed)}">
                <div class="icon">
                    <img
                        src="../../../assets/icons/solar_alt-arrow-{collapsed ? 'up' : 'down'}-outline-white.svg"
                        alt="icon"
                    />
                </div>
            </button>
        </div>
    </div>
    {#if innerWidth < 1700 && showOrderIcon}
        <div class="actionButtonsMobile">
            <ul>
                <slot name="actionButtons" />
            </ul>

            <div>
                <Cta
                    type="BubbleButton"
                    colorForce=" #ADB5BD"
                    content="zum Auftrag"
                    icon="solar_arrow-right-outline"
                    on:click="{() => dispatch('openOrder')}"
                />
            </div>
        </div>
    {/if}
    <div
        class="collapsible"
        class:collapsed="{collapsed}"
    >
        <slot />
    </div>
</div>

<style lang="less">
    @import "../../../assets/variables.less";
    .collapsible-wrapper:global {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .innerHeader {
            background: var(--text-100);
            display: flex;
            justify-content: space-between;
            width: 100%;
            display: flex;
            padding: 0.4rem 1.2rem;

            color: var(--grey-200);
            .title {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                gap: 0.6rem;
                .icon {
                    width: 1.2rem;
                    height: 1.2rem;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
            .buttons {
                flex-grow: 1;
                display: flex;
                justify-content: flex-end;
                gap: 1.2rem;

                .actionButtons > * {
                    display: flex;
                    gap: 6px;
                }
            }
            .content {
                display: flex;
                align-items: center;
                & > li {
                    border-left: 1px solid var(--white-100);
                    padding: 0px 0.6rem;
                    height: fit-content;
                    color: white;
                    &:first-child {
                        border-left: none;
                        padding-left: 0px;
                    }
                    @media @mobile {
                        & > ul {
                            display: flex;
                            flex-direction: column;
                            gap: 0.4rem;
                            & > li {
                                line-height: 0.9rem;
                            }
                        }
                    }
                }
            }
        }
        .actionButtonsMobile {
            padding: 0.6rem 1.2rem;
            display: flex;
            justify-content: space-between;
            width: 100%;
            align-items: center;
            ul {
                .actionButtons {
                    display: flex;
                    gap: 6px;
                }
            }

            background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%), var(--text-100, #6c757d);
        }
        .collapsible {
            max-height: 5000px;
            width: 100%;
            transition: max-height 0.3s ease-out;
            & > .wrapper {
                display: flex;
                flex-direction: column;
                gap: 0.6rem;
            }
            &.collapsed {
                overflow: hidden;
                max-height: 0px;
                transition: max-height 0.3s ease-in;
            }
        }
    }
</style>
